import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkout-status',
  templateUrl: './checkout-status.component.html',
  styleUrls: ['./checkout-status.component.scss']
})
export class CheckoutStatusComponent implements OnInit {
@Input() index: any;
@Input() nextStep: any;
@Input() step: any;
@Input() Pay:any;
@Input() tracking:boolean;
  constructor() { }

  ngOnInit() {
  }

}
